 document.addEventListener("DOMContentLoaded", function(event) {
if (window.innerWidth < 1025) {
  var swiper = new Swiper(".block_tab-collection-3 .block_mobtab-slider", {
    slidesPerView: 2,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      momentumBounce: false,
    },
     scrollbar: {
      el: ".block_tab-collection-3 .swiper-scrollbar",
      hide: false,
       draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-3 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-3 .block_slider-left-arrow",
    },
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      350: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  var swiper = new Swiper(".block_tab-collection-3 .block_mobtab-slider-full", {
    slidesPerView: 4.136,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    freeMode: {
      enabled: true,
      momentumBounce: false,
    },
      scrollbar: {
      el: ".block_tab-collection-3 .swiper-scrollbar",
      hide: false,
       draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-3 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-3 .block_slider-left-arrow",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 1.45,
        spaceBetween: 10,
      },
      580: {
        slidesPerView: 1.45,
        spaceBetween: 10,
      },
    },
  });
} else {
  var swiper = new Swiper(".block_tab-collection-3 .block_tab-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
     scrollbar: {
      el: ".block_tab-collection-3 .swiper-scrollbar",
      hide: false,
       draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-3 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-3 .block_slider-left-arrow",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  var swiper = new Swiper(".block_tab-collection-3 .block_tab-slider-full", {
    slidesPerView: 4.136,
    spaceBetween: 20,
    observer: true,
    observeParents: true,
     scrollbar: {
      el: ".block_tab-collection-3 .swiper-scrollbar",
      hide: false,
       draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-3 .block_slider-right-arrow",
      prevEl: ".block_tab-collection-3 .block_slider-left-arrow",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10,
      },
      400: {
        slidesPerView: 1.45,
        spaceBetween: 10,
      },
      580: {
        slidesPerView: 1.45,
        spaceBetween: 10,
      },
    },
  });
}
 })